import React from 'react';
import InputMask from './InputMask';

const dateMask = [/[0-9]/,/[0-9]/, '/', /[0-9]/,/[0-9]/, '/', /[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/];
export default props => <InputMask {...props} mask_={dateMask} />;
